import $http from "../../axios";
import {
    Notification,
    MessageBox
} from 'element-ui';
import { getApiDomain } from "../../util/domains";



//Obtener los terceros
export async function fetchContacts({commit, state},requestParameters = {params: state.params_contacts}) {
    state.loading.search_contact = true;
    await $http.get('/api/terceros-lite', requestParameters)
        .then((response) => {
            commit('setContacts', response.data.data)
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box',
            });
            commit('contactError', error.message)
        })

        state.loading.search_contact = false;
}

// obtener Data libro Contable
export async function fetchAuxiliaryBookContact({commit, state, dispatch}) {
    state.loading.module = true;
    state.params.download = null;

    await $http.get('/api/libro-auxiliar-tercero', { params : state.params})
        .then((response) => {
            if (response.data.limit_rows){
                Notification.warning({
                    title: 'Atención!',
                    message: 'La información supera los 60 mil registros, el Reporte completo se Descargará ' +
                        'Automáticamente en formato Excel',
                    type: 'warning',
                    duration: 10000,
                    customClass: 'notification-box',
                });
                state.loading.module = false;
                commit('setauxiliary_book', []);
                dispatch('fetchAuxiliaryBookContactExcel');
            } else {
                commit('setauxiliary_book', response.data.data);
                state.loading.module = false;
                state.params.download = null;
            }
        })
        .catch((error) => {
            state.loading.module = false;
            Notification.error({
                title: 'Error!',
                message: (error.response && error.response.data && error.response.data.message) || 'Error al obtener los datos',
                type: 'error',
                duration: 2000,
                customClass: 'notification-box',
            });
        })
}

// Descargar Excel cuando excede el límite de registros
export async function fetchAuxiliaryBookContactExcel({commit, state}) {
    state.params.download = true;
    state.loading.module = true;

    await $http({
        url: `/api/libro-auxiliar-tercero`,
        method: 'GET',
        params: state.params,
    }).then(response => {
        state.loading.module = false;
        state.params.download = null;
        const url = response.data.path;
        const link = document.createElement('a');
        link.href = getApiDomain() + url;
        link.setAttribute('download', response.data.name);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        Notification.success({
            title: 'Éxito!',
            message: 'El archivo se ha descargado correctamente',
            type: 'success',
            duration: 3000,
            customClass: 'notification-box',
        });
    }).catch((error) => {
        state.loading.module = false;
        state.params.download = null;
        Notification.error({
            title: "Error!",
            message: (error.response && error.response.data && error.response.data.message) || 'Error al descargar el archivo',
            type: 'error',
            duration: 1500,
            customClass: 'notification-box'
        });
    })
}


export async function getSubscriber({commit, dispatch, state}) {
    await $http.get(`/api/suscriptor`)
        .then(response => {
            commit('setSubscriber', response.data.data);
        })
        .catch(error => {
            console.error(error);
        });
}



// WEBPACK FOOTER //
// ./src/modules/auxiliary-book-contact/actions.js